import { Trans } from 'react-i18next';
import * as yup from 'yup';

const companyProfileSchema = yup.object().shape({
  name: yup.string().required(<Trans i18nKey="errors.noBusinessName" />),
  companySize: yup.string().required(<Trans i18nKey="errors.noCompanySize" />),
  department: yup.string().required(<Trans i18nKey="errors.noDepartment" />),
  billingAddress: yup.object().shape({
    addressLine1: yup.string().required(<Trans i18nKey="errors.noAddress" />),
    country: yup.string().required(<Trans i18nKey="errors.noCountry" />),
    city: yup.string().required(<Trans i18nKey="errors.noCity" />),
    state: yup.string().required(<Trans i18nKey="errors.noState" />),
    postalCode: yup.string().required(<Trans i18nKey="errors.noPostalCode" />)
  })
});

export { companyProfileSchema };
